import { useQuery } from "@tanstack/react-query";
import { getMe } from "@/api/auth";
import { getAlertRules } from "@/api/alerts";
import { Settings, Key, Users, Bell } from "lucide-react";

export function SettingsPage() {
  const { data: meData } = useQuery({ queryKey: ["me"], queryFn: getMe });
  const { data: rulesData } = useQuery({ queryKey: ["alert-rules"], queryFn: getAlertRules });

  const user = meData?.user as Record<string, unknown> | undefined;
  const rules = rulesData?.rules || [];

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <h1 className="text-2xl font-semibold text-slate-900">Settings</h1>

      {/* Account */}
      <div className="bg-white rounded-xl border border-slate-200">
        <div className="px-6 py-4 border-b border-slate-100 flex items-center gap-2">
          <Settings className="w-4 h-4 text-slate-500" />
          <h2 className="text-sm font-medium text-slate-900">Account</h2>
        </div>
        <div className="px-6 py-4 space-y-3">
          <div className="flex justify-between text-sm">
            <span className="text-slate-500">Email</span>
            <span className="text-slate-900">{user?.email as string || "--"}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-slate-500">Role</span>
            <span className="text-slate-900 capitalize">{user?.role as string || "--"}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-slate-500">Plan</span>
            <span className="text-slate-900 capitalize">{user?.tenant_plan as string || "trial"}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-slate-500">Company Limit</span>
            <span className="text-slate-900">{user?.max_companies as number || 5}</span>
          </div>
        </div>
      </div>

      {/* Alert Rules */}
      <div className="bg-white rounded-xl border border-slate-200">
        <div className="px-6 py-4 border-b border-slate-100 flex items-center gap-2">
          <Bell className="w-4 h-4 text-slate-500" />
          <h2 className="text-sm font-medium text-slate-900">Alert Rules ({rules.length})</h2>
        </div>
        <div className="px-6 py-4">
          {rules.length === 0 ? (
            <p className="text-sm text-slate-400">No alert rules configured</p>
          ) : (
            <div className="space-y-2">
              {rules.map((r: Record<string, unknown>) => (
                <div key={r.id as number} className="flex justify-between items-center text-sm">
                  <span className="text-slate-900">{r.name as string}</span>
                  <span className="text-xs text-slate-500">{r.rule_type as string}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* API Keys placeholder */}
      <div className="bg-white rounded-xl border border-slate-200">
        <div className="px-6 py-4 border-b border-slate-100 flex items-center gap-2">
          <Key className="w-4 h-4 text-slate-500" />
          <h2 className="text-sm font-medium text-slate-900">API Keys</h2>
        </div>
        <div className="px-6 py-8 text-center">
          <p className="text-sm text-slate-400">API key management coming soon</p>
        </div>
      </div>
    </div>
  );
}
